export function getView(value) {
  return value ? 'Board' : 'Home'
}
